<template>
  <div class="contianer">
    <Message :show="message.msg" :message="message" />
    <div class="container-contact100">
      <div class="wrap-contact100">
        <b-form class="contact100-form validate-form">
          <span class="contact100-form-title">Envianos un Mensaje</span>
          <b-label class="label-input100" for="first-name">Nombre *</b-label>
          <div
            class="wrap-input100 rs1-wrap-input100 validate-input"
            data-validate="Type first name"
          >
            <input
              id="first-name"
              class="input100"
              type="text"
              name="first-name"
              placeholder="Nombre"
            />
            <span class="focus-input100"></span>
          </div>
          <div
            class="wrap-input100 rs2-wrap-input100 validate-input"
            data-validate="Type last name"
          >
            <input class="input100" type="text" name="last-name" placeholder="Apellidos" />
            <span class="focus-input100"></span>
          </div>
          <label class="label-input100" for="email">Correo Electrónico *</label>
          <div
            class="wrap-input100 validate-input"
            data-validate="Valid email is required: ex@abc.xyz"
          >
            <input
              id="email"
              class="input100"
              type="text"
              name="email"
              placeholder="correo@dominio.com"
            />
            <span class="focus-input100"></span>
          </div>
          <label class="label-input100" for="phone">Teléfono de Contacto</label>
          <div class="wrap-input100">
            <input id="phone" class="input100" type="text" name="phone" placeholder="+52 1234-5678" />
            <span class="focus-input100"></span>
          </div>
          <label class="label-input100" for="message">Mensaje *</label>
          <div class="wrap-input100 validate-input" data-validate="Message is required">
            <textarea id="message" class="input100" name="message" placeholder="Escribe tu mensaje"></textarea>
            <span class="focus-input100"></span>
          </div>
          <div class="container-contact100-form-btn">
            <button class="contact100-form-btn">Enviar</button>
          </div>
        </b-form>
        <div
          class="contact100-more flex-col-c-m"
          style="background-image: url('images/bg-01.jpg');"
        >
          <div class="flex-w size1 p-b-47">
            <div class="txt1 p-r-25">
              <span class="lnr lnr-map-marker"></span>
            </div>
            <div class="flex-col size2">
              <span class="txt1 p-b-20">Direccción</span>
              <span class="txt2">Mariano Escobedo 476, C.P. 11590 CDMX México</span>
            </div>
          </div>
          <div class="dis-flex size1 p-b-47">
            <div class="txt1 p-r-25">
              <span class="lnr lnr-phone-handset"></span>
            </div>
            <div class="flex-col size2">
              <span class="txt1 p-b-20">Hablemos!</span>
              <span class="txt3">+52 55 1493 6785</span>
            </div>
          </div>
          <div class="dis-flex size1 p-b-47">
            <div class="txt1 p-r-25">
              <span class="lnr lnr-envelope"></span>
            </div>
            <div class="flex-col size2">
              <span class="txt1 p-b-20">Atención</span>
              <span class="txt3">
                <b-link href="mailto:info@fintech-coatl.solutions">info@fintech-coatl.solutions</b-link>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Message from "../components/Message";

export default {
  name: "Contact",
  components: {
    Message
  },
  data() {
    return {
      message: {}
    };
  }
};
</script>


<style lang="scss" scoped>
@import "../assets/styles/_contact.sass";
@import "../assets/styles/_util.sass";
</style>